import {
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAIL,
  GET_DOCUMENT_BY_ID,
  GET_DOCUMENT_BY_ID_SUCCESS,
  GET_DOCUMENT_BY_ID_FAIL,
  ADD_DOCUMENT,
  ADD_DOCUMENT_SUCCESS,
  ADD_DOCUMENT_FAIL,
  DELETE_DOCUMENT,
  DELETE_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT_FAIL,
  CLEAR_DOCUMENTS,
  RESET_DOCUMENT_FLAG,
} from "./actionTypes"

// Get Documents
export const getDocuments = (entityId, entityType) => ({
  type: GET_DOCUMENTS,
  payload: { entityId, entityType },
})

export const getDocumentsSuccess = documents => ({
  type: GET_DOCUMENTS_SUCCESS,
  payload: documents,
})

export const getDocumentsFail = error => ({
  type: GET_DOCUMENTS_FAIL,
  payload: error,
})

// Get Document By Id
export const getDocumentById = id => ({
  type: GET_DOCUMENT_BY_ID,
  payload: id,
})

export const getDocumentByIdSuccess = document => ({
  type: GET_DOCUMENT_BY_ID_SUCCESS,
  payload: document,
})

export const getDocumentByIdFail = error => ({
  type: GET_DOCUMENT_BY_ID_FAIL,
  payload: error,
})

// Add Document
export const addDocument = formData => ({
  type: ADD_DOCUMENT,
  payload: formData,
})

export const addDocumentSuccess = document => ({
  type: ADD_DOCUMENT_SUCCESS,
  payload: document,
})

export const addDocumentFail = error => ({
  type: ADD_DOCUMENT_FAIL,
  payload: error,
})

// Delete Document
export const deleteDocument = id => ({
  type: DELETE_DOCUMENT,
  payload: id,
})

export const deleteDocumentSuccess = id => ({
  type: DELETE_DOCUMENT_SUCCESS,
  payload: id,
})

export const deleteDocumentFail = error => ({
  type: DELETE_DOCUMENT_FAIL,
  payload: error,
})

// Clear Documents
export const clearDocuments = () => ({
  type: CLEAR_DOCUMENTS,
})

// Reset Flag
export const resetDocumentFlag = () => ({
  type: RESET_DOCUMENT_FLAG,
})
